export default __webpack_public_path__ + "static/media/4978b097b01c1a19ad8d9d443c1e234d.svg";